import React from "react";

/**
 * Full-viewport branded loading state. Used anywhere we would otherwise
 * return `null` during app startup — replaces the "blank white screen"
 * the app used to show while Auth + Terms were resolving on first paint.
 */
export default function AppLoading({ testid = "app-loading" }) {
  return (
    <div
      data-testid={testid}
      role="status"
      aria-live="polite"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#F5F6F8",
        fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, fontWeight: 700, fontSize: 20, color: "#1A1A1A" }}>
          <span
            style={{
              display: "inline-block",
              width: 32,
              height: 32,
              background: "#005CFF",
              borderRadius: 8,
              color: "#fff",
              textAlign: "center",
              lineHeight: "32px",
              fontSize: 16,
            }}
          >S</span>
          Squad Fee
        </div>
        <div
          aria-hidden="true"
          style={{
            width: 24,
            height: 24,
            border: "2px solid #E5E7EB",
            borderTopColor: "#005CFF",
            borderRadius: "50%",
            animation: "sf-spin 0.8s linear infinite",
          }}
        />
        <span style={{ position: "absolute", left: -9999, width: 1, height: 1, overflow: "hidden" }}>
          Loading Squad Fee…
        </span>
        <style>{`@keyframes sf-spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
